// src/components/Profile.js
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import API_URL from '../config';
import { apiFetch } from '../utils/auth';
import { useEmployeeId } from '../context/RoleContext';

function Profile() {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  const { id } = useParams();
  const myEmployeeId = useEmployeeId();


  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await apiFetch(`${API_URL}/employees/${id}`);
      if (!res.ok) throw new Error('Сотрудник не найден');
      const data = await res.json();
      setProfile(data);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (loading) return <div className="loading">Загрузка проектов...</div>;
  if (error) return <div className="error">Ошибка: {error}</div>;
  if (!profile) return <div>Профиль сотрудника не найден.</div>;

  return (
    <div>

      {/* заглушка вместо смены аватара, по центру страницы */}
      <div
        style={{
          margin: '40px 12px 24px',
          textAlign: 'center',
          fontSize: 16,
        }}
      >
        Раздел в разработке.
        <br />
        Скоро тут появится интеграция с 1С.
      </div>

      {/* нижний тапбар рендерится глобально в App */}
    </div>
  );
}

export default Profile;
